<template>
  <div class="file-sidebar">
    <div class="card">
      <div class="card-body">
        <ul class="media-sidebar">
          <li v-for="sidebar in sidebarMenus" :key="sidebar">
            <button @click="executeFunction(sidebar.title)" style="width: 100%">
              <div :class="[sidebar.btnClass, { active: activeSidebar === sidebar.title }]">
                {{ sidebar.title }}
              </div>
            </button>
          </li>
        </ul>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { sidebarMenus } from "../../data/filemanager/sidebar";
export default {
  props: ["clickMore"],
  data() {
    return {
      sidebarMenus: sidebarMenus,
      activeSidebar: 'Home',
    };
  },

  methods: {
    executeFunction(type) {
      // Call the custom function passed from the parent component
      this.clickMore(type);
      this.activeSidebar = type;
    },
  },
};
</script>

<style scoped>
.media-sidebar {
  padding-left: 0 !important;
}

.active {
  background-color: #ffbc0d !important;
  color: white !important;
}
</style>
